export const COLLECTION = {
  EVENTS: 'events',
  POSTERS: 'posters',
  USERS: 'users',
};



// WEBPACK FOOTER //
// ./src/constants/collection.js